var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDarkTheme = function SvgDarkTheme(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.511 16.96.417.276a.5.5 0 0 0-.639-.724zM15.568 3.735l.059.496a.5.5 0 0 0 .139-.955zM3.5 12A8.5 8.5 0 0 1 12 3.5v-1A9.5 9.5 0 0 0 2.5 12zm8.5 8.5A8.5 8.5 0 0 1 3.5 12h-1a9.5 9.5 0 0 0 9.5 9.5zm7.094-3.816A8.49 8.49 0 0 1 12 20.5v1a9.49 9.49 0 0 0 7.928-4.264zm.195-.172a6.5 6.5 0 0 1-2.885.673v1a7.5 7.5 0 0 0 3.33-.777zm-2.885.673a6.5 6.5 0 0 1-6.5-6.5h-1a7.5 7.5 0 0 0 7.5 7.5zm-6.5-6.5c0-3.326 2.5-6.07 5.723-6.454l-.119-.993a7.5 7.5 0 0 0-6.604 7.447zM12 3.5a8.5 8.5 0 0 1 3.37.694l.396-.918A9.5 9.5 0 0 0 12 2.5z",
    className: "fill-icon-main"
  })));
};
export default SvgDarkTheme;